import type { LevelTableColumn } from 'redesign';
import { Chip, styled, Typography } from '@mui/material';
import { TableCell, TableHeader } from 'redesign';
import { IconFlexPoolOnlyJob } from 'assets/img';
import { useGetShiftDetailsColumnDefinitionBase } from 'shared/components/shift-detail-modal/components/tabs/shared/columns/use-get-shift-details-column-definition-base';
import { useTranslation } from 'react-i18next';
import {
  CancelledCellPropsProject,
  CancelledColumnDefinitionProject,
  CancelledTableOptionsProject,
} from '../types/cancelled-table-project.types';

export const useGetCancelledColumnDefinitionProject: () => LevelTableColumn<
  CancelledColumnDefinitionProject,
  CancelledTableOptionsProject
>[] = () => {
  const { t } = useTranslation('hq-screen-specific');
  const [flexWorkerImage, fw] = useGetShiftDetailsColumnDefinitionBase();

  const cancellationReason: LevelTableColumn<
    CancelledColumnDefinitionProject,
    CancelledTableOptionsProject
  > = {
    Header: '',
    accessor: 'cancellationReason',
    Cell: CancellationReasonCell,
  };

  const flexPoolIndicator: LevelTableColumn<
    CancelledColumnDefinitionProject,
    CancelledTableOptionsProject
  > = {
    Header: '',
    accessor: 'flexPoolIndicator',
    Cell: FlexPoolIndicatorCell,
  };
  const hourlyRate: LevelTableColumn<
    CancelledColumnDefinitionProject,
    CancelledTableOptionsProject
  > = {
    Header: () => (
      <TableHeader>
        {t('projects.cancellations.table_headers.hourly_rate', { ns: 'hq-screen-specific' })}
      </TableHeader>
    ),
    accessor: 'hourlyRate',
    Cell: HourlyRateCell,
  };

  return [flexWorkerImage, cancellationReason, flexPoolIndicator, fw, hourlyRate];
};

const HourlyRateCell = ({ value }: CancelledCellPropsProject<'hourlyRate'>) => {
  return (
    <TableCell>
      {value.toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      })}
    </TableCell>
  );
};

const FlexPoolIndicatorCell = ({ value }: CancelledCellPropsProject<'flexPoolIndicator'>) => {
  return value ? <IconFlexPoolOnlyJob width={24} /> : null;
};

const CancellationReasonCell = ({ value }: CancelledCellPropsProject<'cancellationReason'>) => {
  return <StyledChip size="small" label={<Typography variant="body2">{value}</Typography>} />;
};

const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.warning.main,
}));
